import React, { FC } from 'react';

import { Box, BoxProps, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import ResultPanel from '@components/share/data-display/resultPanel';

type ResultPanelEmptyDataProps = {
  sx?: BoxProps['sx'];
};

const ResultPanelEmptyData: FC<ResultPanelEmptyDataProps> = ({ sx }) => {
  const { t } = useTranslation('common');

  const theme = useTheme();

  return (
    <ResultPanel
      icon={<Box component="img" src="/static/images/common/empty-data.svg" />}
      title={
        <Typography variant="h5" color={theme.palette.textV2.disabled}>
          {t('result_panel.empty_data.title')}
        </Typography>
      }
      rootSx={{ bgcolor: theme.palette.grey[100], borderRadius: 4, ...sx }}
    />
  );
};

export default ResultPanelEmptyData;
